import { ConfirmModal } from 'components/modal';
import { usePopupContext } from 'context/PopupContext';
import { brlDate } from 'util/format';

const getDayText = (date: string | null): string => {
    if (!date) return '';

    const normalize = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const target = normalize(new Date(date));
    const today = new Date();
    const tomorrow = new Date(today);

    tomorrow.setDate(today.getDate() + 1);

    if (target === normalize(today)) return 'hoje, ';
    if (target === normalize(tomorrow)) return 'amanhã, ';

    return '';
};

export function GradeModal() {
    const { dataGrade, openGradeModal, setOpenGradeModal } = usePopupContext();
    const dtLimitePedido = dataGrade ? `${dataGrade?.dtLimitePedido}T00:00:00` : null;
    const dayText = getDayText(dtLimitePedido);

    return (
        <ConfirmModal
            open={openGradeModal}
            setOpen={setOpenGradeModal}
            showCancel={false}
            title="Grade"
            confirmText="Fechar"
            text={
                <>
                    Sua data limite para digitação de <b>{dataGrade?.tipoGrade?.dsTipoGrade?.toUpperCase()}</b> vence {dayText}dia{' '}
                    <b> {dtLimitePedido && brlDate(dtLimitePedido)}</b>
                </>
            }
        />
    );
}
